import { Button } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';

const ButtonGray = ({ children, onClick, ...props }: ButtonProps) => {
  return (
    <Button
      variant="subtle"
      color="fg"
      bg="bg.subtle"
      borderRadius="xl"
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
};

const MemoizedButtonGray = memo(ButtonGray);
export { MemoizedButtonGray as ButtonGray };
